import moment from 'moment'

const dateParser = (year, month, day) => {
    if (!year || !month || !day) return
    const formattedDate = moment(`${year}/${month}/${day}`).format('YYYY-MM-DD')
    return formattedDate
}

export default dateParser